module.exports = __webpack_public_path__ + "img/1_02.06ee7b63.jpg";